export default {
    methods: {
        unsetUserLocationIfOld() {
            const userLocation =
                this.$store.getters['currentUser/getUserLocation'];
            const userLocationDate =
                this.$store.getters['currentUser/getUserLocationDate'];
            const sessionKey = this.$store.getters['currentUser/getSessionKey'];
            if (sessionKey && userLocation) {
                const today = new Date();
                const currentDate =
                    today.getFullYear() +
                    '-' +
                    (today.getMonth() + 1) +
                    '-' +
                    today.getDate();
                if (currentDate != userLocationDate) {
                    this.$store.commit(
                        'currentUser/unsetUserLocation',
                        undefined,
                        { root: true }
                    );
                }
            }
        },
    },
    beforeRouteEnter(to, from, next) {
        this.unsetUserLocationIfOld();
        next();
    },
};
